import { Template, LazyTemplate } from "../../template/index";
import { View } from "../../view/index";

export default class TabControlView extends View
{
    public template = Template.lazy('/core/views/tabControl/index.html');   
    public data: TabControlData;
    
    private headers: Element[];
    private pages: Element[];

    private tabPages: {header: Element, page: Element, id: string}[];

    constructor(data?: TabControlData)
    {
        super(data);
        this.headers = [];
        this.pages = [];
        this.tabPages = [];
    }

    public resolveTabPageId(tabPage: TabPage)
    {
        return tabPage.id !== undefined ? tabPage.id : tabPage.title;
    }

    public resolveTabheaderClassNames(tabPage: TabPage)
    {
        let result: string[] = [];
        let id = this.resolveTabPageId(tabPage);

        if (id === this.data.activePage)
        {
            result.push('active');
        }
        
        return result.length > 0 ? ` ${result.join(' ')}` : '';
    }

    public resolveTabPageClassNames(tabPage: TabPage)
    {
        let result: string[] = [];
        let id = this.resolveTabPageId(tabPage);
        
        if (id === this.data.activePage)
        {
            result.push('active');
        }
        if (this.data.tabPageClassNames != null)
        {
            result.push(this.data.tabPageClassNames);
        }
        if (tabPage.classNames != null)
        {
            result.push(tabPage.classNames);
        }

        return result.length > 0 ? ` ${result.join(' ')}` : '';
    }

    public afterRender(): PromiseLike<void>
    {
        const headers = this.element.querySelectorAll('.tab-header');

        for(let header of headers)
        {
            let id = header.getAttribute('data-tab-header');
            let page = this.element.querySelector(`[data-tab-page="${id}"]`);
            this.headers.push(header);
            this.pages.push(page);

            this.tabPages.push({
                header: header,
                page: page,
                id: id
            });
        }
        return super.afterRender();
    }

    public onTabHeaderClick(e: MouseEvent)
    {
        let target = e.currentTarget as Element;
        let tabPage = this.tabPages.find(o => o.header === target);
        if (tabPage != null)
        {
            this.activatePage(tabPage.page, target);
            this.trigger(`activate:${tabPage.id}`, e);
        }
    }

    private activatePage(page: Element, header?: Element)
    {
        header = header !== undefined ? header : this.tabPages.find(o => o.page === page).header;

        for(let header of this.headers)
        {
            header.classList.remove('active');
        }

        for (let page of this.pages)
        {
            page.classList.remove('active');
        }

        header.classList.add('active');
        page.classList.add('active');
    }

    public get activePage(): string
    {
        let page = this.pages.find(o => o.classList.contains('active'));
        if (page)
        {
            return page.getAttribute('data-tab-page');
        }
    }

    public set activePage(id: string)
    {
        let page = this.pages.find(o => o.getAttribute('data-tab-page') === id);
        if (page)
        {
            this.activatePage(page);
        }   
    }

    public getPage(id: string)
    {
        let tabPage = this.tabPages.find(o => o.id === id);
        if (tabPage)
        {
            return tabPage.page;
        }
    }
}

export interface TabPage
{
    title: string;
    id?: string;
    itemCount?: number;
    classNames?: string;
}

export interface TabControlData
{
    pages: TabPage[];
    activePage?: string;
    tabPageClassNames?: string;
}